import { render, staticRenderFns } from "./Demographics.vue?vue&type=template&id=bb3c337e&scoped=true"
import script from "./Demographics.vue?vue&type=script&lang=js"
export * from "./Demographics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c337e",
  null
  
)

export default component.exports